import React from 'react';

import styles from './ButtonsGroup.module.scss';
import { useButtonsGroupAnimation } from './useButtonsGroupAnimation';

interface ButtonsGroupProps {
  children: React.ReactNode;
  className?: string;
}

export const ButtonsGroup: React.FC<ButtonsGroupProps> = ({ children, className }) => {
  const { groupRef, indicatorRef } = useButtonsGroupAnimation();

  return (
    <div className={`${styles.wrapper} ${className ?? ''}`} ref={groupRef}>
      {children}
      <div ref={indicatorRef} className={styles.indicator} />
    </div>
  );
};